module.exports = __webpack_public_path__ + "img/body-3-lg.e59158ce.png";